export default [
  {
    id: 0,
    name: "IoT Device Management",
    icon: "iot-management.svg",
    alt: "IoT Device Management icon",
    productCard: {
      position: { left: 3.9 },
      description:
        "A secure, enterprise-grade edge infrastructure and IoT device management solution for both IT and operational technology organizations and any IoT use case.",
      image: "vmware-pulse-iot-center.jpg",
      imageTwo: "vmware-pulse-iot-center.webp",
      bullets: [
        {
          name: "VMware Pulse IoT Center",
          description:
            "VMware Pulse IoT Center is a secure, enterprise-grade edge infrastructure and IoT device management solution that helps you onboard, manage, monitor, and secure your connected devices and gateways.",
          link: "https://vmware.com/products/pulse-iot-device-management.html"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 54, left: 5 }
      },
      {
        position: { top: 45.2, left: 8.5 }
      },
      {
        position: { top: 40.4, left: 9.5 }
      },
      {
        position: { top: 58.3, left: 18 }
      },
      {
        position: { top: 37, left: 19 }
      },
      {
        position: { top: 49.6, left: 23 }
      },
      {
        position: { top: 46.2, left: 33.5 }
      },
      {
        position: { top: 37, left: 39 }
      },
      {
        position: { top: 55, left: 43 }
      },
      {
        position: { top: 54.5, left: 48 }
      },
      {
        position: { top: 29, left: 51 }
      },
      {
        position: { top: 45, left: 57 }
      },
      {
        position: { top: 32.2, left: 64.5 }
      },
      {
        position: { top: 44.8, left: 66 }
      },
      {
        position: { top: 40.3, left: 74.1 }
      },
      {
        position: { top: 51.2, left: 76.5 }
      },
      {
        position: { top: 36.5, left: 81 }
      },
      {
        position: { top: 39.2, left: 89.5 }
      },
      {
        position: { top: 46.5, left: 95 }
      }
    ],
    isActive: false
  },
  {
    id: 2,
    name: "Edge Devices",
    icon: "gateway.svg",
    alt: "Edge Devices icon",
    productCard: {
      position: { left: 20.6 },
      description:
        "Highly effective industrial gateways and embedded PCs designed to connect to legacy devices—even in extreme conditions.",
      image: "gateway-and-embedded.jpg",
      imageTwo: "gateway-and-embedded.webp",
      bullets: [
        {
          name: "Dell Edge Gateways",
          description:
            "Dell Edge Gateways aggregate, secure, and relay data from diverse sensors and equipment to activate your IoT solutions and smart systems.",
          link:
            "https://www.dell.com/en-us/work/shop/scc/sc/gateways-embedded-pcs?~ck=mn"
        },
        {
          name: "Dell Embedded Box PCs",
          description:
            "Dell embedded PCs are rugged, fanless devices that integrate with operational IT technology to support your IoT solutions and smart systems.",
          link:
            "https://www.dell.com/en-us/work/shop/scc/sc/gateways-embedded-pcs?~ck=mn"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 46, left: 6 }
      },
      {
        position: { top: 36, left: 16 }
      },
      {
        position: { top: 64, left: 28 }
      },
      {
        position: { top: 40.1, left: 32.5 }
      },
      {
        position: { top: 33, left: 41.6 }
      },
      {
        position: { top: 59, left: 42.5 }
      },
      {
        position: { top: 30, left: 49 }
      },
      {
        position: { top: 34.6, left: 62 }
      },
      {
        position: { top: 48.5, left: 65 }
      },
      {
        position: { top: 43.9, left: 80 }
      },
      {
        position: { top: 44, left: 82.5 }
      },
      {
        position: { top: 49, left: 94 }
      }
    ],
    isActive: false
  },
  {
    id: 3,
    name: "Network Connectivity",
    icon: "network.svg",
    alt: "Network Connectivity icon",
    productCard: {
      position: { left: 37.3 },
      description:
        "Specific areas where various parts of a network connect (cellular, low-powered, Bluetooth, and SD-WAN networks), including networking hardware, network virtualization, and security software.",
      image: "istock-907916910.jpg",
      imageTwo: "istock-907916910.webp",
      bullets: [
        {
          name: "VMware NSX SD-WAN by VeloCloud",
          description:
            "VMware SD-WAN by VeloCloud provides enterprise-grade wide-area networks through broadband and private links and offers a platform for virtual service delivery.",
          link: "https://www.vmware.com/products/sd-wan-by-velocloud.html"
        },
        {
          name: "VMware NSX",
          description:
            "VMware NSX provides network virtualization technology for creating segments within your networks that minimize threats spreading from one end of your network to the other.",
          link: "https://www.vmware.com/products/nsx.html"
        },
        {
          name: "Dell EMC PowerSwitch Networking",
          description:
            "Dell EMC open networking solutions help organizations to achieve unprecedented levels of flexibility, efficiency, and  innovation.",
          link: "https://www.dellemc.com/en-us/networking/index.htm"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 58, left: 16.5 }
      },
      {
        position: { top: 42.9, left: 35.3 }
      },
      {
        position: { top: 33, left: 39.5 }
      },
      {
        position: { top: 39, left: 74.9 }
      }
    ],
    isActive: false
  },
  {
    id: 4,
    name: "Hybrid Cloud Infrastructure",
    icon: "hybrid-cloud.svg",
    alt: "Hybrid Cloud Infrastructure icon",
    productCard: {
      position: { left: 53.9 },
      description:
        "A platform to create and manage applications, secure and store IoT data, and run analytics on any cloud.",
      image: "hybrid-cloud-inf.jpg",
      imageTwo: "hybrid-cloud-inf.webp",
      bullets: [
        {
          name: "VMware Cloud via Amazon Web Services",
          description:
            "VMware Cloud on Amazon Web Services is a hybrid cloud solution that allows you to modernize, protect, and scale vSphere-based applications.",
          link: "https://cloud.vmware.com/vmc-aws"
        },
        {
          name: "VMware Cloud Foundation",
          description:
            "VMware Cloud Foundation provides a complete set of software-defined services for compute, storage, networking, security, and cloud management to run enterprise apps in private or public environments.",
          link: "https://www.vmware.com/products/cloud-foundation.html"
        },
        {
          name: "Dell EMC Servers and Storage",
          description:
            "Dell EMC's software-defined enterprise hybrid cloud simplifies how IT scales resources and provides broker services between a choice of private or public clouds.",
          link: "https://www.dellemc.com/en-us/servers/index.htm"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 60, left: 10 }
      },
      {
        position: { top: 37, left: 75 }
      }
    ],
    isActive: false
  },
  {
    id: 5,
    name: "Edge Computing",
    icon: "micro-datacenter.svg",
    alt: "Edge Computing icon",
    productCard: {
      position: { left: 70.5 },
      description:
        "A combination of hardware, software, network, and analytics that serve as a local end-to-end edge solution and reside close to where the data is generated from devices.",
      image: "vmware-digitalfoundation.jpg",
      imageTwo: "vmware-digitalfoundation.webp",
      bullets: [
        {
          name: "VMware Cloud on Dell EMC",
          description:
            "VMware Cloud on Dell EMC is a fully managed VMware service that provides simple, secure, and scalable infrastructure for the customer’s on-premises data center and edge locations.",
          link: "https://www.vmware.com/products/vmc-on-dell-emc.html"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 45, left: 12 }
      },
      {
        position: { top: 36.8, left: 22.5 }
      },
      {
        position: { top: 64.9, left: 26 }
      },
      {
        position: { top: 43.2, left: 32.5 }
      },
      {
        position: { top: 32.8, left: 36.5 }
      },
      {
        position: { top: 57, left: 46.7 }
      },
      {
        position: { top: 30, left: 66 }
      },
      {
        position: { top: 47.5, left: 67 }
      },
      {
        position: { top: 39.6, left: 85 }
      },
      {
        position: { top: 49, left: 98 }
      }
    ],
    isActive: false
  },
  {
    id: 6,
    name: "Data Integration, Analytics, and App Services",
    icon: "machine-learning.svg",
    alt: "Data Integration, Analytics and App Services icon",
    productCard: {
      position: { left: 82.8 },
      description:
        "A combination of services that integrate IoT data with business systems and build applications that use data from connected devices.",
      image: "business-intelligence-big-data.jpg",
      imageTwo: "business-intelligence-big-data.webp",
      bullets: [
        {
          name: "Dell Boomi",
          description:
            "Dell Boomi is a cloud-native, high-productivity integration platform that supports your application and data integration needs across your hybrid IT landscape.",
          link: "https://boomi.com/"
        },
        {
          name: "Pivotal Data Suite",
          description:
            "The Pivotal Data Suite features software for developing and deploying innovative applications.",
          link: "https://pivotal.io/partners/dell-technologies"
        },
        {
          name: "Partner Analytics Applications and App Services",
          description:
            "Our rich ecosystem of IoT partners is available to help you simplify IoT complexity and accelerate the return on investment for your IoT use cases.",
          link:
            "https://www.vmware.com/solutions/edge-internet-of-things/partners.html"
        }
      ]
    },
    productIconPositions: [
      {
        position: { top: 47, left: 3.7 }
      },
      {
        position: { top: 37.4, left: 14 }
      },
      {
        position: { top: 64.6, left: 30 }
      },
      {
        position: { top: 40.6, left: 35.2 }
      },
      {
        position: { top: 59, left: 39.5 }
      },
      {
        position: { top: 32.5, left: 44.8 }
      },
      {
        position: { top: 28, left: 53 }
      },
      {
        position: { top: 44.5, left: 81 }
      },
      {
        position: { top: 37.5, left: 73 }
      },
      {
        position: { top: 50, left: 91.8 }
      }
    ],
    isActive: false
  }
];
